var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.112,
    height: 14.918,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 200",
    d: "M11.494 2.87l-.951 10.838H3.57L2.619 2.87l-1.2.106.968 11.035a1.018 1.018 0 001 .907h7.338a1.02 1.02 0 001.006-.915l.968-11.027z",
    fill: "#fc035d"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 201",
    d: "M9.273 0h-4.44a1.009 1.009 0 00-1 1.008v1.915h1.21V1.21h4.032v1.713h1.21V1.008A1.009 1.009 0 009.273 0z",
    fill: "#fc035d"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 202",
    d: "M13.507 2.318H.607a.605.605 0 100 1.21h12.9a.605.605 0 100-1.21z",
    fill: "#fc035d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d27f2f6602bb4e208d5a27c8da2ed65b.svg";
export { ForwardRef as ReactComponent };